import { customAlphabet } from "nanoid";

// One alphabet for all new short IDs. Keep legacy readers permissive so
// existing IDs containing hyphens or underscores continue to resolve.
const generateIdSuffix = customAlphabet(
  "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz",
);

/** Length counts random characters only; an empty prefix produces a bare ID. */
export function generateId(prefix: string, length = 12): string {
  const suffix = generateIdSuffix(length);
  return prefix ? `${prefix}-${suffix}` : suffix;
}

export const generateUserId = () => generateId("u", 10);
export const generateOrganizationDatasetSnapshotId = () => generateId("ods");
export const generateAsyncRunId = () => generateId("ar");
export const generateAsyncRunStepId = () => generateId("ars");
export const generateTranscriptArtifactId = () => generateId("ta");
export const generateRoundTranscriptSummaryArtifactId = () =>
  generateId("rtsa");
export const generateNoteScoreArtifactId = () => generateId("nsca");
export const generateNoteDensityArtifactId = () => generateId("nda");
export const generateNoteSentimentArtifactId = () => generateId("nsta");
export const generateKeyPeopleExtractionArtifactId = () => generateId("kpea");
export const generateProposalSummaryExtractionArtifactId = () =>
  generateId("psea");
export const generateKeyIndividualResearchReportArtifactId = () =>
  generateId("kirra");
export const generateFactCheckArtifactId = () => generateId("fca");
export const generateMvfQualityRatingArtifactId = () => generateId("mvfqa");
export const generateMvfQualityTranscriptExtractId = () => generateId("mvfqte");
export const generateAiQuestionAnswerArtifactId = () => generateId("aqaa");
export const generateSharedAiQuestionAnswerArtifactId = () =>
  generateId("saqaa");
export const generateRecommenderSummaryArtifactId = () => generateId("rnsa");
export const generateRecommenderProposalNoteSummaryArtifactId = () =>
  generateId("rpnsa");
export const generateProposalTrackNoteSummaryArtifactId = () =>
  generateId("ptnsa");
export const generateTrackSummaryArtifactId = () => generateId("tks");
export const generateRoundSummaryArtifactId = () => generateId("rds");
export const generateScoreRubricArtifactId = () => generateId("sra");
export const generatePromptImprovementArtifactId = () => generateId("pia");
export const generateDevStructuredThinkingArtifactId = () => generateId("dsta");
export const generateDevResearchReportArtifactId = () => generateId("drra");
export const generateProposalDeepResearchArtifactId = () => generateId("pdra");
export const generateProposalTheoryOfCaseArtifactId = () => generateId("ptca");
export const generatePastProposalMatchArtifactId = () => generateId("ppma");
export const generateProposalWeightArtifactId = () => generateId("pwa");
export const generateInformednessScoreArtifactId = () => generateId("isa");
export const generateRecommenderWeightArtifactId = () => generateId("rwa");
export const generateSpeculatorDiscussionArtifactId = () => generateId("sda");
export const generatePromptContextId = () => generateId("pc");
export const generateBenchmarkResultId = () => generateId("bench");

export const generateApplicationAssessmentArtifactId = () => generateId("aaa");
